import { z } from "zod";
import {
  DTOCreateForgeProjectInvitation,
  DTOForgeProjectInvitationCreateResponse,
  DTOForgeProjectInvitationsListResponse,
  DTOUpdateForgeProjectInvitation,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class ForgeProjectInvitationsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(projectId: string) {
    return this.requestExecutor.json(
      `/forge/projects/${projectId}/invitations`,
      DTOForgeProjectInvitationsListResponse,
      {
        method: "GET",
      }
    );
  }

  create(projectId: string, body: DTOCreateForgeProjectInvitation) {
    return this.requestExecutor.json(
      `/forge/projects/${projectId}/invitations`,
      DTOForgeProjectInvitationCreateResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  update(projectId: string, email: string, body: DTOUpdateForgeProjectInvitation) {
    return this.requestExecutor.json(
      `/forge/projects/${projectId}/invitations/${encodeURI(email)}`,
      DTOForgeProjectInvitationCreateResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  delete(projectId: string, email: string) {
    return this.requestExecutor.json(
      `/forge/projects/${projectId}/invitations/${encodeURI(email)}`,
      z.object({ ok: z.literal(true) }),
      {
        method: "DELETE",
      }
    );
  }
}
